import * as React from 'react';
const AiChatbotIcon = (props) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5497 14.1809C12.6091 14.2313 12.6924 14.2426 12.7631 14.2099C12.8338 14.1772 12.8791 14.1063 12.8791 14.0284V12.3323C12.8791 11.891 13.2496 11.523 13.7194 11.523H14.8358C15.7113 11.523 16.4314 10.833 16.4314 9.96918V2.58457C16.4314 1.72073 15.7113 1.03072 14.8358 1.03072H3.16419C2.28877 1.03072 1.56867 1.72073 1.56867 2.58456V9.96918C1.56867 10.833 2.28877 11.523 3.16419 11.523H6.96568C8.54763 11.523 10.0749 12.0801 11.264 13.0895L12.5497 14.1809ZM13.9478 12.3538C13.8373 12.3538 13.7478 12.4433 13.7478 12.5538V15.3846C13.7478 15.5441 13.6515 15.693 13.495 15.7619C13.3377 15.8311 13.1535 15.8042 13.0252 15.6952L10.6874 13.7108C9.65631 12.8355 8.3338 12.3538 6.96568 12.3538H3.16419C1.7975 12.3538 0.700012 11.2805 0.700012 9.96918V2.58456C0.700012 1.27325 1.7975 0.199951 3.16419 0.199951H14.8358C16.2025 0.199951 17.3 1.27325 17.3 2.58457V9.96918C17.3 11.2805 16.2025 12.3538 14.8358 12.3538H13.9478Z"
      fill="currentColor"
    />
    <path
      d="M3.16419 3.75447C3.16419 3.51348 3.35956 3.31812 3.60055 3.31812H11.3823C11.6233 3.31812 11.8186 3.51348 11.8186 3.75447C11.8186 3.99547 11.6233 4.19083 11.3823 4.19083H3.60055C3.35956 4.19083 3.16419 3.99547 3.16419 3.75447Z"
      fill="currentColor"
    />
    <path
      d="M3.60055 5.83972C3.35956 5.83972 3.16419 6.03509 3.16419 6.27608C3.16419 6.51707 3.35956 6.71244 3.60055 6.71244H9.38226C9.62325 6.71244 9.81862 6.51707 9.81862 6.27608C9.81862 6.03509 9.62325 5.83972 9.38226 5.83972H3.60055Z"
      fill="currentColor"
    />
    <path
      d="M3.60055 8.31812C3.35956 8.31812 3.16419 8.51348 3.16419 8.75447C3.16419 8.99547 3.35956 9.19083 3.60055 9.19083H6.38226C6.62325 9.19083 6.81862 8.99547 6.81862 8.75447C6.81862 8.51348 6.62325 8.31812 6.38226 8.31812H3.60055Z"
      fill="currentColor"
    />
  </svg>
);
export default AiChatbotIcon;
